import axios from 'axios';
import { parse_response_data as parse_api_response_data } from '@/utils/api_response_helpers';
import {
  GET_VERIFICATION_SERVICES,
  get_request_config,
} from '@/utils/system_constants/constant.js';
import {
  applyVerificationGuidanceState,
  normalizeVerificationGuidance,
  resetVerificationGuidanceState,
} from './create_sections_verification_helpers.js';

export const create_sections_verification_methods = {
  parse_response_data(response) {
    return parse_api_response_data(response);
  },

  format_required_field_label(value) {
    return String(value ?? '')
      .replace(/[_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  },

  set_active_verification_service(service_id) {
    const id = String(service_id ?? '').trim();
    if (id) this.verification_active_service_id = id;
  },

  has_verification_guidance_context() {
    const has_verification_context = (
      this.is_verification_form_context &&
      Number(this.verification_form_id)
    );
    return has_verification_context;
  },

  start_verification_guidance_loading() {
    this.verification_guidance_loading = true;
  },

  finish_verification_guidance_loading() {
    this.verification_guidance_loading = false;
  },

  async load_verification_guidance() {
    if (!this.has_verification_guidance_context()) {
      return;
    }

    this.start_verification_guidance_loading();
    try {
      await this.fetch_verification_guidance();
    } finally {
      this.finish_verification_guidance_loading();
    }
  },

  fetch_verification_guidance() {
    return axios
      .get(GET_VERIFICATION_SERVICES, get_request_config())
      .then((services_resp) => {
        const services_data = this.parse_response_data(services_resp);
        const guidance_state = normalizeVerificationGuidance(services_data);

        applyVerificationGuidanceState(
          this,
          guidance_state.services,
          guidance_state.required_by_service
        );
      })
      .catch((error) => {
        resetVerificationGuidanceState(this);
        console.warn('Failed to load verification guidance', error);
      });
  },
};
